import script from "./contentPortofolio.vue?vue&type=script&setup=true&lang=js"
export * from "./contentPortofolio.vue?vue&type=script&setup=true&lang=js"

import "./contentPortofolio.vue?vue&type=style&index=0&id=7d02362b&lang=css"

const __exports__ = script;

export default __exports__